export default {
      id: "command__password-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#command__password",
      toString: function () {
        return this.url;
      }
    }